import * as api from '../api';

export function updateBusinesses(businesses) {
  return {
    type: 'BUSINESSES_UPDATE_ALL',
    businesses
  }
}

export function updateBusiness(business) {
  return {
    type: 'BUSINESSES_UPDATE_ONE',
    business
  }
}

export function resetBusinesses() {
  return {
    type: 'BUSINESSES_RESET'
  }
}

// Thunks
export function getBusinessesAPI() {
  return function(dispatch) {
    return api.getBusinesses().then(
      (businesses) => dispatch(updateBusinesses(businesses)),
      (error) => console.warn(error)
    );
  }
}

export function getBusinessAPI(businessId) {
  return function(dispatch) {
    return api.getBusiness(businessId).then(
      (business) => dispatch(updateBusiness(business)),
      (error) => console.warn(error)
    );
  }
}

export function updateBusinessAPI(businessId, data) {
  return function(dispatch) {
    return api.updateBusiness(businessId, data).then(
      (business) => dispatch(updateBusiness(business)),
      (error) => console.warn(error)
    );
  }
}
